import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { CreateConclusionRequest } from 'app/core/models/conclusion/create-conclusion.model';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConclusionService {
  constructor(private apiService: ApiService) {}

  private apiURL = `${environment.apiLocations.patient}/conclusion`;

  createConclusion(request: CreateConclusionRequest) {
    return this.apiService.post<any>(
      `${this.apiURL}/createConclusion`,
      request
    );
  }

  checkConclusion(patientId: string, woundId: string) {
    return this.apiService.get<any>(
      `${this.apiURL}/checkConclusion?patientId=${patientId}&woundId=${woundId}`
    );
  }

  getConclusionDetailByWoundId(woundId: string) {
    return this.apiService.get<any>(
      `${this.apiURL}/getConclusionDetailByWoundId?WoundId=${woundId}`
    );
  }

  completeConclusion(
    woundId: string, 
    nurseNote?: string
  ) {
    return this.apiService.post<any>(`${this.apiURL}/completeConclusion`, {
      woundId,
      nurseNote,
    });
  }
}
